// extracted by mini-css-extract-plugin
export var label = "Label-module--label--2nDUs";
export var invalid = "Label-module--invalid--2ltc0";